if (!customElements.get('selected-collection-grid')) {
  customElements.define('selected-collection-grid', class extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const link = event.target.closest('.pagination-wrapper a');
        if (!link || !this.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.loadPage(link);
      };
      this.addEventListener('click', this.onClick);
      this.observeNextPage();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
      this.controller?.abort();
    }

    observeNextPage() {
      this.observer?.disconnect();
      const link = this.querySelector('[data-load-more]');
      if (this.dataset.pagination !== 'infinite' || !link) return;
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.observer.disconnect();
          this.loadPage(link);
        }
      }, { rootMargin: '200px' });
      this.observer.observe(link);
    }

    async loadPage(link) {
      if (this.loading) return;
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();
      try {
        const url = new URL(link.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Unable to load collection products');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = Array.from(html.querySelectorAll('selected-collection-grid')).find(
          (element) => element.dataset.sectionId === this.dataset.sectionId
        );
        if (!updated || !updated.querySelector('[data-product-grid]')) throw new Error('Missing product grid');
        if (!this.isConnected) return;
        if (link.hasAttribute('data-load-more')) {
          this.querySelector('[data-product-grid]').insertAdjacentHTML('beforeend', updated.querySelector('[data-product-grid]').innerHTML);
          const pagination = this.querySelector('.pagination-wrapper');
          const nextPagination = updated.querySelector('.pagination-wrapper');
          if (nextPagination) pagination.replaceWith(nextPagination);
          else pagination.remove();
        } else {
          const containerId = `SelectedProductGridContainer-${this.dataset.sectionId}`;
          const container = this.querySelector('[id="' + containerId + '"]');
          container.innerHTML = html.getElementById(containerId).innerHTML;
          container.setAttribute('tabindex', '-1');
          container.focus({ preventScroll: true });
          container.scrollIntoView({ block: 'start' });
        }
        this.observeNextPage();
      } catch (error) {
        if (error.name !== 'AbortError') {
          // Keep the ordinary pagination URL as a fallback if AJAX fails.
          window.location.assign(link.href);
        }
      } finally {
        this.loading = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
}
